export default __webpack_public_path__ + "static/media/business-model-health-check.5607fb6f.svg";